import { Component, Inject, Input, ViewChild } from '@angular/core';
import * as _ from 'underscore';
import { ReplaySubject, Subscription } from 'rxjs';
import { MatOption } from '@angular/material/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MondelezDataService } from '../../services/mondelez-data.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalFilter } from '../../interfaces/global-filter-model';
import { GlobalFilterService } from '../../services/global-filter.service';

@Component({
  selector: 'app-global-filter-dialog',
  templateUrl: './global-filter-dialog.component.html',
  styleUrls: ['./global-filter-dialog.component.scss'],
})
export class GlobalFilterDialogComponent {
  @Input() initiateFromDialog = false;

  @ViewChild('allSelectedPlant') public allSelectedPlant: MatOption;
  @ViewChild('allSelectedLine') public allSelectedLine: MatOption;
  @ViewChild('allSelectedProdFormat') public allSelectedProdFormat: MatOption;
  @ViewChild('allSelectedPackFormat') public allSelectedPackFormat: MatOption;

  private subscriptions = new Subscription();

  public maxYearOptionLimit: number;
  public globalFilterForm: FormGroup;
  public selectedMasterPlan: any = {};
  public filterIconFlag: any = {};
  public initialFiltersValues: any = {};
  public currentFilter: any;
  public filteredList: any = {};
  public filterBtnClicked = true;

  public manufacturingFilters = {
    firm_type: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
    category: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
    brand: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
    manufacturing_network: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
    geography: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
    plant_code: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
    line_code: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
    product_format: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
    pack_format: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
  };

  public currentFilterScreen: string | undefined; // Set this based on incoming data
  public visibleElements: { [key: string]: string[] } = {
    bdIntSummary: ['selectPeriod', 'plant', 'line', 'productFormat', 'packFormat'],
    sci_simulation_mfg_screen: ['plant', 'line', 'productFormat', 'packFormat'],
    sci_kpiDashboard_mfg_screen: ['plant', 'line', 'productFormat', 'packFormat'],
    sci_mups_screen: ['plant', 'line'],
  };

  constructor(
    private fb: FormBuilder,
    private mondelezDataService: MondelezDataService,
    private globalFilterService: GlobalFilterService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<GlobalFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.currentFilter = this.globalFilterService.currentPopupFilters;
    if (this.data) {
      this.filteredList = this.data.filterMasterData;
      this.currentFilterScreen = this.data.filterScreenName;
    }
    this.createForm();
    this.initializeValues();

    _.each(this.manufacturingFilters, (value, key) => {
      this.manufacturingFilters[key].filterCtrl.valueChanges.subscribe(() => {
        this.filterFilters(key, this.manufacturingFilters);
      });
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  isVisible(element: string): boolean {
    if (!this.currentFilterScreen) return false;
    return this.visibleElements[this.currentFilterScreen]?.includes(element) || false;
  }

  protected filterFilters(field, filters) {
    if (!filters[field].values) {
      return;
    }
    // get the search keyword
    let search = filters[field].filterCtrl.value;
    if (!search) {
      filters[field].filtered.next(filters[field].values.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filters[field].filtered.next(filters[field].values.filter((el) => el.toLowerCase().indexOf(search) > -1));
  }

  public initFilterData(data, formField, filters) {
    _.each(filters, (value, key) => {
      if (key != formField) {
        let dataList;
        dataList = _.sortBy(_.uniq(_.pluck(data, key)));
        filters[key].values = dataList;
        filters[key].filtered.next(dataList.slice());
      }
    });
  }

  initializeValues() {
    if (this.filteredList.length > 0) {
      this.initFilterData(this.filteredList, '', this.manufacturingFilters);
      this.globalFilterForm.patchValue({
        start_quarter: this.currentFilter?.start_quarter,
        end_quarter: this.currentFilter?.end_quarter,
      });

      this.subscriptions.add(
        this.globalFilterService.globalPopupFilters.subscribe((value: GlobalFilter) => {
          if (value && Object.keys(value).length !== 0) {
            this.globalFilterForm.patchValue({ ...value });
            this.applyFilter();
          } else {
            this.resetNewGlobalFilter();
          }
        })
      );

      this.subscriptions.add(
        this.mondelezDataService.currentScenarioChanged.subscribe((scenario) => {
          if (scenario) {
            if (this.filterBtnClicked) this.filterBtnClicked = false;
            else this.resetNewGlobalFilter();
          }
        })
      );
    }
  }

  private createForm() {
    this.globalFilterForm = this.fb.group({
      plant_code: [[]],
      line_code: [[]],
      product_format: [[]],
      pack_format: [[]],
      geography: [null],
      start_quarter: null,
      end_quarter: null,
    });
  }

  handleOpenedChange(isOpened, formFiled) {
    this.filterIconFlag[formFiled] = isOpened;
    if (isOpened) {
      this.setInitialFilterFormValues(formFiled);
    } else {
      if (this.initialFiltersValues.hasOwnProperty(formFiled)) {
        const initialValue = this.initialFiltersValues[formFiled];
        const currentValue = this.globalFilterForm.controls[formFiled].value;
        if ((initialValue === null && (currentValue === null || (Array.isArray(currentValue) && currentValue.length === 0))) === false) {
          const valueChanged = this.isValueChanged(initialValue, currentValue);
          if (valueChanged) {
            this.globalFilterService.updateGlobalPopupFiltersSelection(this.globalFilterForm.value);
          }
        }
      }
    }
  }

  setInitialFilterFormValues(formFiled) {
    this.initialFiltersValues[formFiled] = this.globalFilterForm.controls[formFiled].value;
  }

  isValueChanged(initialValue: any, currentValue: any): boolean {
    if (Array.isArray(initialValue) && Array.isArray(currentValue)) {
      if (initialValue.length !== currentValue.length) {
        return true;
      } else {
        return !initialValue.every((element) => {
          if (currentValue.includes(element)) {
            return true;
          }
          return false;
        });
      }
    } else {
      return initialValue !== currentValue;
    }
  }

  applyFilter() {
    const plant_code = this.globalFilterForm.value['plant_code'] || [];
    const line_code = this.globalFilterForm.value['line_code'] || [];
    const product_format = this.globalFilterForm.value['product_format'] || [];
    const pack_format = this.globalFilterForm.value['pack_format'] || [];
    const geography = this.globalFilterForm.value['geography'] || [];

    let masterData: any = [];

    const filter_options = [
      { key: 'plant_code', values: plant_code, display_label: 'plant_name' },
      { key: 'line_code', values: line_code, display_label: 'line_code' },
      { key: 'product_format', values: product_format, display_label: 'product_format' },
      { key: 'pack_format', values: pack_format, display_label: 'pack_format' },
      { key: 'geography', values: geography, display_label: 'geography' },
    ];

    masterData = JSON.parse(JSON.stringify(this.filteredList));

    filter_options.forEach((el) => {
      const temp = masterData.filter((item) => {
        return filter_options
          .filter((filter) => filter.key !== el.key)
          .every((row) => {
            if (row.values.length === 0) return true;
            return row.values.includes(item[row.key]);
          });
      });
      if (temp.length > 0) {
        temp.sort((a, b) => a[el.display_label].localeCompare(b[el.display_label]));
      }

      const uniqueValues = _.uniq(this.getkeysfilter(el.key, structuredClone(temp)));
      this.manufacturingFilters[el.key].filtered.next(uniqueValues);
    });
  }

  getkeysfilter(key, data) {
    return data.map((ele) => ele[key]);
  }

  toggleAllSelection(formField, alloptions) {
    let masterData: any;
    masterData = this.manufacturingFilters;
    if (alloptions.selected) {
      let allOptions = [];
      masterData[formField].filtered.subscribe((res) => {
        allOptions = res;
      });
      let newValues = allOptions.map((item) => {
        return item;
      });
      newValues.push('');
      const temp = this.globalFilterForm.get(formField);
      temp.patchValue([...newValues]);
    } else {
      const temp = this.globalFilterForm.get(formField);
      temp.patchValue([]);
    }
  }

  togglePerOne(formField, alloptions) {
    let masterData: any;
    masterData = this.manufacturingFilters;
    if (alloptions.selected) {
      alloptions.deselect();
      return false;
    }
    const temp = this.globalFilterForm.get(formField);
    let allOptions = [];
    masterData[formField].filtered.subscribe((res) => {
      allOptions = res;
    });
    if (temp.value && temp.value.length == allOptions.length) alloptions.select();
    return '';
  }

  applyFilters() {
    const cleanedFilter = this.cleanFilterObject(this.globalFilterForm.value);
    this.globalFilterService.updateGlobalPopupFiltersSelection(cleanedFilter);
    this.dialogRef.close({ filterForm: this.globalFilterForm, action: 'apply' });
  }

  onClose(action): void {
    if (action === 'clear') {
      this.resetNewGlobalFilter();
      this.dialogRef.close({ filterForm: this.globalFilterForm, action: action });
    } else {
      this.dialogRef.close({ action: 'close' });
    }
  }

  onYearsSelected(eventData: { year1; year2 }) {
    this.globalFilterForm.patchValue({
      start_quarter: eventData.year1,
      end_quarter: eventData.year2,
    });
  }

  resetNewGlobalFilter() {
    this.globalFilterForm.reset();
    this.globalFilterService.updateGlobalPopupFiltersSelection(this.globalFilterForm.value);
  }

  cleanFilterObject(filter: any): any {
    return Object.keys(filter).reduce((acc, key) => {
      let value = filter[key];

      if (Array.isArray(value)) {
        acc[key] = value.filter((item) => item !== '');
      } else {
        acc[key] = value;
      }

      return acc;
    }, {} as any);
  }
}
